import React, { Component } from 'react'
import { Card, CardBody, Row, Col, Label, Spinner } from 'reactstrap'
import ReactHtmlParser from 'react-html-parser'
import { request } from '@octokit/request'
import marked from 'marked'
import moment from 'moment'
import { notifyError } from '../../utils/notify'
import './Updates.css'

export default class Updates extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      releases: [],
    }
  }

  async componentDidMount() {
    try {
      this.setState({ loading: true })

      const releases = await request('GET /repos/{owner}/{repo}/releases', {
        headers: {
          authorization: `token ${process.env.REACT_APP_GITHUB_TOKEN}`,
        },
        owner: process.env.REACT_APP_GITHUB_REPO_OWNER,
        repo: process.env.REACT_APP_GITHUB_REPO_NAME,
        per_page: 3,
      })

      console.tron.log('releases', releases)

      this.setState({ loading: false, releases: releases.data })
    } catch (err) {
      notifyError('Não foi possível obter as últimas atualizações.')
      this.setState({ loading: false, releases: [] })
    }
  }

  render() {
    const { loading, releases } = this.state

    return (
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h4 className="card-title mb-4">Atualizações</h4>
            </Col>
          </Row>
          {loading && (
            <Row>
              <Col className="d-flex align-items-center justify-content-center py-2">
                <Spinner size="sm" />
              </Col>
            </Row>
          )}
          {!loading && releases && releases.length > 0 && (
            releases.map((release, index) => (
              <Row key={release.name} className="releases-item">
                <Col>
                  <Label>
                    {moment(release.published_at).format('DD/MM/YY')}
                  </Label>
                  <br />
                  <h6>
                    {release.name}
                  </h6>
                  {ReactHtmlParser(marked(release.body))}
                  {index !== releases.length - 1 && (
                    <hr style={{ marginBottom: 24, marginTop: 24 }} />
                  )}
                </Col>
              </Row>
            ))
          )}
        </CardBody>
      </Card>
    )
  }
}
